<template>
    <div></div>
</template>

<script>

export default {
  name: 'Home',
  components: {},
  data () {
    return {

    }
  },
  mounted () {
    location.href = 'http://www.fiscool.com/'
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Home.vue